export const isNumeric = (num: any) => {
  if (
    (typeof num === 'number' ||
      (typeof num === 'string' && num.trim() !== '')) &&
    !isNaN(num as number)
  )
    return true;

  return false;
};
